import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "components/ui/accordion";
import { questions, contact } from "../content";
export default function FAQ() {
  return (
    <section className="site-wrap site-faq">
      <h2>
        A few things
        <br />
        you might be wondering.
      </h2>
      <Accordion type="single" collapsible>
        {questions.map(({ question, answer }) => (
          <AccordionItem key={question} value={question}>
            <AccordionTrigger>{question}</AccordionTrigger>
            <AccordionContent>{answer}</AccordionContent>
          </AccordionItem>
        ))}
        <AccordionItem value="urgent">
          <AccordionTrigger>Who do I contact in an emergency?</AccordionTrigger>
          <AccordionContent>
            For after-hours property emergencies, call{" "}
            <a className="site-inline-link" href={contact.emergencyTelephone}>
              {contact.emergency}
            </a>
            . For everyday enquiries, call{" "}
            <a className="site-inline-link" href={contact.telephone}>
              {contact.phone}
            </a>
            .
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </section>
  );
}
